/**
 * Connection Status Indicator
 * Shows connection state and provides reconnect button when disconnected
 */

import React from 'react';
import { useNotifications, CONNECTION_STATES } from '../context/NotificationContext';

export default function ConnectionStatus() {
  const { connectionState, forceReconnect } = useNotifications();

  // Don't show anything when connected
  if (connectionState === CONNECTION_STATES.CONNECTED) {
    return null;
  }

  const isConnecting = connectionState === CONNECTION_STATES.CONNECTING;
  const isError = connectionState === CONNECTION_STATES.ERROR;

  return (
    <div className={`fixed bottom-20 left-1/2 transform -translate-x-1/2 z-50
      px-4 py-2 rounded-full shadow-lg flex items-center gap-2 text-sm
      ${isError ? 'bg-red-500 text-white' : 'bg-yellow-500 text-yellow-900'}`}
    >
      {isConnecting ? (
        <>
          <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
          <span>Reconnecting...</span>
        </>
      ) : (
        <>
          <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636a9 9 0 010 12.728m-3.536-3.536a4 4 0 010-5.656m-7.072 7.072a9 9 0 010-12.728m3.536 3.536a4 4 0 010 5.656" />
          </svg>
          <span>Disconnected</span>
          <button
            onClick={forceReconnect}
            className="ml-2 px-2 py-0.5 bg-white bg-opacity-20 rounded hover:bg-opacity-30 transition-colors font-medium"
          >
            Reconnect
          </button>
        </>
      )}
    </div>
  );
}
